var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"SignalList"},[_c('el-select',{model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},_vm._l((_vm.options),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.portfolioName,"value":item.id}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }